var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "quartz-core": "static-1.6436"
    },
    "depPathPrefixes": {
      "quartz-core": "/quartz-core/static-1.6436"
    },
    "bundlingPackage": "billing-portal-ui",
    "bundlingPackageVersion": "static-1.1781",
    "project": "quartz-core",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};